import { OverwriteTranslationsDto } from '@routellers/types/dist/translation/overwrite-translations.dto';

import { ApiMethodDeclaration } from '..';

type ParamsData = { data: OverwriteTranslationsDto };

type ResponseData = { updated: number; missing: string[] };

export const overwriteTranslations: ApiMethodDeclaration<ParamsData, ResponseData> = ({
    data,
}) => ({
    url: '/translations/overwrite',
    method: 'POST',
    data,
});
